<script>

import RequestToJoinUConnectCorporateDialog from "../../../common/requestToJoinUConnectCorporateDialog.vue";
import {mapActions} from "vuex";
import headerNav from "../steps/stepsHeader.vue";
import footNav from "../steps/stepsFooter.vue";

export default {

  name: "uConnectSelectPlanStep",
  components: {footNav, headerNav, RequestToJoinUConnectCorporateDialog},

  data() {
    return {
      activeStep: 1,
      step1a: true,
      step1b: false,
      showSignIn: false,
      requestToJoinDialogVisible: false,
      products: [],
      loginForm: {
        email: "",
        password: ""
      },
      rules: {
        email: [
          {required: true, message: "Please input your email", trigger: "blur"},
          {type: "email", message: "Please input a valid email", trigger: "blur"}
        ],
      }
    };
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return {};
      }
    },


  },
  mounted() {

  },
  methods: {
    ...mapActions("login", ["signIn"]),
    ...mapActions("uConnect", ["getUConnectSubscriptionProducts","updateUConnectUserPackageDetails"]),
    goNext() {
      var that = this;
      console.log("goNext");
      // this.$emit('stepChanged', 1);

      // this.$router.push("/uconnect/register/select-plan-details");
      that.$router.push({ name: 'uConnectSelectPlanDetailsStep' },
          () => {
            console.log('Navigation successful')
          },
          (error) => {
            console.log('Navigation failed:', error)
          }
      )
      // this.$store.commit("uConnect/updateUConnectUserEmail", this.loginForm.email);
    },
    contactUs() {
      this.requestToJoinDialogVisible = true;

    },
    subscribeNow(productId) {
      console.log("params-PD*********" );
       var uConnectRegistrationKey = localStorage.getItem("uConnectRegistrationKey");
      const params = {
        userId: this.$store.state.uConnect.userId,
        email: this.$store.state.uConnect.email,
        uConnectRegistrationKey: uConnectRegistrationKey,
        stripeProductId: productId
      }
      console.log("params-PD***************", params);
      this.updateUConnectUserPackageDetails({ params, callback: this.updateUConnectUserPackageDetailsCallback })
    },
    updateUConnectUserPackageDetailsCallback(res) {
      if (res.data.code == 0) {

        this.$emit('stepChanged', 2);

      }
    },
    login() {
      var that = this;
      that.signIn({
        params: {
          email: that.loginForm.email,
          password: that.loginForm.password
        },
        callback: that.loginCallback
      });

    },
    loginCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        ga(
            "send",
            "event",
            "login",
            that.loginForm.email,
            res.data.data.firstName + " " + res.data.data.lastName
        );
        var previousPath = localStorage.getItem('previousPath');
        localStorage.clear();

        localStorage.setItem("uConnectRegisterToken", res.data.data.token);
        if (previousPath) {
          that.$router.replace(previousPath);
        }
      } else if (res.data.code == 70010) {
        that.warn2 = true;
      } else if (res.data.code == 40007) {
        that.warn = true;
      } else if (
          res.data.code == 90000 ||
          res.data.code == 90002 ||
          res.data.code == 90001
      ) {
      }
    },
    getUConnectSubscriptionProductsCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        this.products = res.data.data;
      }
    },
  }

}
</script>

<template>
<!--  <el-container :lg="3" :md="4" :sm="6" :xl="1" :xs="8" class="mainWrapper">-->
<!--    <el-header style="padding: 0; height: 104px">-->
<!--      <header-nav v-bind:gray="gray" :activeIndexPage="'how-it-works'"></header-nav>-->
<!--    </el-header>-->
<!--    <el-main style="padding: 0; overflow: visible;">-->
<!--      <el-steps :active="activeStep-1" align-center finish-status="success">-->
<!--        <el-step title="Step 1" description="Plan"></el-step>-->
<!--        <el-step title="Step 2" description="User Details"></el-step>-->
<!--        <el-step title="Step 3" description="payment"></el-step>-->
<!--      </el-steps>-->
      <div>
          <div class="plan-selection">
            <el-row type="flex" justify="center" align="middle">
              <el-col :xs="24" :sm="20" :md="16" :lg="12" :xl="10">
                <el-card class="selection-card">
                  <!-- Step Indicator Row -->
                  <el-row type="flex" justify="center">
                    <el-col :span="24">
                      <div class="step-indicator">
                        <div class="step-text">STEP 1 OF 3</div>
                      </div>
                    </el-col>
                  </el-row>

                  <!-- Title Row -->
                  <el-row>
                    <el-col :span="24">
                      <h1 class="title">Choose your plan.</h1>
                    </el-col>
                  </el-row>

                  <!-- Features List Row -->
                  <el-row class="features-container">
                    <el-col :span="24">
                      <div class="features-list">
                        <!-- Feature 1 -->
                        <el-row class="feature-item">
                          <el-col :span="2">
                            <i class="el-icon-check"></i>
                          </el-col>
                          <el-col :span="22">
                            <div class="feature-text">
                              <span>Unlock New Revenue Streams</span>
                              <span>and Market Access</span>
                            </div>
                          </el-col>
                        </el-row>

                        <!-- Feature 2 -->
                        <el-row class="feature-item">
                          <el-col :span="2">
                            <i class="el-icon-check"></i>
                          </el-col>
                          <el-col :span="22">
                            <div class="feature-text">
                              <span>Exclusive Off-Market Opportunities</span>
                            </div>
                          </el-col>
                        </el-row>

                        <!-- Feature 3 -->
                        <el-row class="feature-item">
                          <el-col :span="2">
                            <i class="el-icon-check"></i>
                          </el-col>
                          <el-col :span="22">
                            <div class="feature-text">
                              <span>Collaborate in a Powerful</span>
                              <span>Professional Network</span>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                  </el-row>

                  <!-- Button Row -->
                  <el-row>
                    <el-col :span="24">
                      <el-button type="primary" class="next-button" @click="goNext">Next</el-button>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
            </el-row>
          </div>
      </div>


<!--    </el-main>-->
<!--    <el-footer style="padding: 0">-->
<!--      <foot-nav :showQus="showFootTxt"></foot-nav>-->
<!--    </el-footer>-->
<!--  </el-container>-->
</template>

<style scoped lang="css">
/* #step1a */
.plan-selection {
  min-height: 100vh;
  padding: 20px;
  background-color: #f5f7fa;
}

.selection-card {
  padding: 30px;
}

.step-indicator {
  margin-bottom: 24px;
}

.step-badge {
  display: inline-block;
}

.step-badge >>> .el-badge__content {
  background-color: #333;
  color: white;
  border: none;
}

.step-text {
  font-size: 14px;
  color: #606266;
  letter-spacing: 1px;
}

.title {
  font-size: 28px;
  color: #303133;
  margin-bottom: 32px;
  font-weight: 600;
  text-align: center;
}

.features-container {
  margin: 32px 0;
}

.features-list {
  text-align: left;
}

.feature-item {
  margin-bottom: 20px;
  align-items: flex-start;
}

.feature-item:last-child {
  margin-bottom: 0;
}

.el-icon-check {
  color: #409EFF;
  font-size: 20px;
  margin-top: 3px;
}

.feature-text {
  display: flex;
  flex-direction: column;
  color: #303133;
  font-size: 16px;
  line-height: 1.4;
}
.sign-in-btn, .join-btn {
  width: 100%;
  background-color: #003333;
  border-color: #003333;
  border-radius: 5px;
  padding: 15px 0;
  height: max-content;
  font: 500 20px DINosaur-a, sans-serif;
  color: #ffffff;
}
.next-button,.subscribe-button, .contact-us-button {
  width: 100%;
  height: 44px;
  margin-top: 32px;
  font-size: 16px;
  background-color: #003333;
  border-color: #003333;
  color: #ffffff;
}

.next-button:hover {
  background-color: #003333;
  border-color: #003333;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .selection-card {
    padding: 20px;
  }

  .title {
    font-size: 24px;
  }

  .feature-text {
    font-size: 14px;
  }
}

/* #step1b */
.pricing-container {
  padding: 20px;
  text-align: center;
}

.pricing-card {
  min-height: 10%;
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.pricing-header {
  font-size: 18px;
  font-weight: bold;
  background: #1f4e78;
  color: white;
  padding: 10px;
  border-radius: 5px;
}

ul {
  list-style: none;
  padding: 0;
  margin: 20px 0;
}

li {
  font-size: 16px;
  margin: 10px 0;
}

.check {
  color: #27ae60;
  font-size: 20px;
}

.cross {
  color: #e74c3c;
  font-size: 20px;
}

.info-text {
  margin-top: 20px;
  font-size: 14px;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/register/uConnectRegistration/selectPackage/uConnectSelectPlanStep.vue